import { InsightInfo } from '../types';

export function mapInsightInfo(insightInfo: InsightInfo): Record<string, string | string[]> {
  if (!insightInfo?.tags) {
    return {};
  }

  return insightInfo.tags.reduce((prev, current) => {
    if (prev[current.key]) {
      if (Array.isArray(prev[current.key])) {
        prev[current.key] = [...prev[current.key], current.value];
      } else {
        prev[current.key] = [prev[current.key], current.value];
      }
    } else {
      prev[current.key] = current.value;
    }

    return prev;
  }, {});
}
